import { useState } from "react";
import { tags } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const hotTags = new Set(["分站特色", "板块差异", "专属区块", "主站对照", "独立玩法"]);

export default function TopicWall() {
  const [active, setActive] = useState<string>("分站特色");

  return (
    <section id="topics" className="scroll-mt-32 bg-secondary-50 border-y border-secondary-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="话题标签墙"
          icon="ri-price-tag-3-line"
          title="把零散内容串成一条线"
          desc="标签墙是黑料网5专属的方向索引。想顺着一个话题往下追，从标签进去比盲目翻页更省事；每个标签背后都对应一组同方向的内容。"
        />

        <div className="mt-10 rounded-lg border border-secondary-200 bg-background-50 p-5 md:p-7">
          <div className="flex flex-wrap gap-2.5 md:gap-3">
            {tags.map((tag) => {
              const isActive = active === tag;
              const isHot = hotTags.has(tag);
              return (
                <button
                  key={tag}
                  type="button"
                  onClick={() => setActive(tag)}
                  className={`px-3.5 py-2 rounded-full font-label text-xs md:text-sm border transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 border-primary-500 text-foreground-950 font-medium"
                      : isHot
                        ? "bg-accent-100 border-accent-200 text-accent-900 hover:bg-accent-200"
                        : "bg-background-50 border-secondary-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  {tag}
                </button>
              );
            })}
          </div>

          <div className="mt-7 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div className="flex items-start gap-3">
              <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-filter-3-line text-[18px]"></i>
              </span>
              <div className="flex flex-col">
                <span className="font-label text-xs text-foreground-500">
                  当前选中话题
                </span>
                <span className="mt-0.5 font-heading text-base font-semibold text-foreground-950">
                  {active}
                </span>
              </div>
            </div>
            <p className="font-body text-sm text-foreground-600 max-w-xl">
              选择「{active}」后，页面会按该方向聚合对应分站与专属区块，方便你沿着同一条线继续看下去。
            </p>
            <a
              href="#blocks"
              className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-accent-500 text-background-50 font-label text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看该方向板块
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-[14px]"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}